import { SendRequest } from './SendRequest';

export enum QueryTypes {
  GetQuoteMutation = 'GET_QUOTE'
}

export async function GraphQLRequest<T = any, V = any>(query: string, variables?: V): Promise<T> {
  const response = await SendRequest({
      url: '',
      method: 'POST',
      data: {
        query,
        variables,
      },
    })

  return response?.data?.data || {};
}
